import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'

class InvoiceDiv extends React.Component {
	state = {
		id: this.props.id || 0,
		advanceExpenseID: this.props.advanceExpenseID || 0,
	}

	componentDidMount = () => {
		const { id } = this.state
		this.handlerGetInvoice(id)
	}

	handlerGetInvoice = (id) => {
		const { advanceExpenseID } = this.state
		Tyan.doPostEvent({
			event: 'GetInvoice',
			data: { id, advanceExpenseID },
			onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
				}
			}
		})
	}

	handlerSave = () => {
		const { onClose, onSave } = this.props
		const { id, advanceExpenseID, changedValues基本信息 } = this.state

		var limit = Tyan.checkForm.checkLimitedDesc(this)
		if (limit) {
			Tyan.pubForm.showError(limit)
			return
		}

		Tyan.doPostEvent({
			event: 'SaveInvoice',
			data: { id, advanceExpenseID, changedValues基本信息 },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					onClose && onClose()
					onSave && onSave()
				}
			}
		})
	}

	AddInvoiceInfo = () => {
		addListItem(this, {}, '基本信息', '发票明细')
	}

	DelInvoiceInfo = (id) => {
		deleteListItem(this, '基本信息', '发票明细', id)
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteInvoice',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	canSave = () => {
		return getFormValue(this, '基本信息', '发票号码') &&
			getFormValue(this, '基本信息', '发票日期')
		// getFormValue(this, '基本信息', '原币含税金额') &&
		// getFormValue(this, '基本信息', '税率')
	}

	AutoCalculation = (id) => {
		const 税率 = getFormValue(this, '基本信息', '税率', { id, listName: '发票明细' })
		const 原币含税金额 = getFormValue(this, '基本信息', '原币含税金额', { id, listName: '发票明细' })
		const 汇率 = getFormValue(this, '基本信息', '汇率')
		var 原币未税金额 = 0
		var 本币含税金额 = 0
		var 本币未税金额 = 0
		var d税率 = 0
		if (税率) {
			if (税率 == 'CN01：增值税13%')
				d税率 = 0.13
			else if (税率 == 'CN02：增值税9%')
				d税率 = 0.09
			else if (税率 == 'CN03：增值税6%')
				d税率 = 0.06
			else if (税率 == 'CN04：增值税3%')
				d税率 = 0.03
			else if (税率 == 'CN05：增值税1%')
				d税率 = 0.01
		}
		if (汇率 && 原币含税金额) {
			// 原币未税金额 = 原币含税金额 * (1 - d税率)
			// 本币含税金额 = 原币含税金额 * 汇率
			// 本币未税金额 = 原币含税金额 * 汇率 * (1 - d税率)
			原币未税金额 = 原币含税金额 / (1 + d税率)
			本币含税金额 = 原币含税金额 * 汇率
			本币未税金额 = (原币含税金额 * 汇率) / (1 + d税率)
		}
		changeListItem(this, { 原币未税金额, 本币含税金额, 本币未税金额 }, {}, '基本信息', '发票明细', id)
	}

	fieldset基本信息 = () => {
		const { list } = getListItems(this, '基本信息', '发票明细')
		const s = { minWidth: 100, flex: 1 }
		return [
			{ _text: '发票号码', minWidth: '95%', required: true },
			{ _date: '发票日期', minWidth: '95%', required: true },
			{
				_group: '', minWidth: '95%', margin: 0, padding: 0, items: [
					{ _label: '原币含税金额', ...s },
					{ _label: '税率', ...s, minWidth: 200 },
					{ _label: '原币未税金额', ...s },
					{ _label: '本币含税金额', ...s },
					{ _label: '本币未税金额', ...s },
					{ _label: '', minWidth: '25px' },
				]
			},
			{
				_group: '', minWidth: '95%', margin: 0, padding: 0, items: list.map(o => {
					return {
						_group: '', list: { id: o.id, listName: '发票明细' }, minWidth: '95%', margin: 0, padding: 0, items: [
							{ _float: '', name: '原币含税金额', ...s, onChange: () => this.AutoCalculation(o.id), required: true },
							{ _select: '', name: '税率', ...s, minWidth: 200, onChange: () => this.AutoCalculation(o.id), required: true },
							{ _float: '', name: '原币未税金额', ...s },
							{ _float: '', name: '本币含税金额', ...s },
							{ _float: '', name: '本币未税金额', ...s },
							{
								_buttons: [
									{
										_button: '', btnName: '删除', icon: 'trash-o', ui: 'decline', margin: 0, padding: 0,
										handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.DelInvoiceInfo(o.id) })
									}
								], width: '25px', margin: 0, padding: 0,
							}
						]
					}
				})
			},
			{
				_buttons: [
					{ _button: '添加', docked: 'right', handler: this.AddInvoiceInfo },
				], margin: 0, flex: 0,
			},
			{ _text: '备注', minWidth: '95%', maxRows: 3 },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly } = this.props
		const { errorMessage, id, initValues基本信息 } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		return <Body data={this} maxWidth="800"
			controls={
				readOnly ? [
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				] :
					[
						{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(this.canSave() && this.bChanged()), },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete, disabled: this.bChanged() },
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
				]
			}
		/>
	}
}

export default connect()(InvoiceDiv)